export const topBarController = () => {
    const topBarElements = [...document.querySelectorAll('.js-promotion-top-bar')];

    if (topBarElements.length === 0) {
        return;
    }

    const activateTopBar = (index) => {
        topBarElements[index]?.classList.remove('d-none');
    };

    const disactivateTopBar = (index) => {
        topBarElements[index]?.classList.add('d-none');
    };

    let activeTopBarIndex = 0;

    topBarElements.sort((a, b) => Number(b.dataset.sortOrder) - Number(a.dataset.sortOrder));

    topBarElements.forEach((el, index) => {
        if (el.classList.contains('hidden-by-cookies')) {
            activeTopBarIndex = index + 1;
        }
    });

    if (activateTopBar !== 0) {
        activateTopBar(activeTopBarIndex);
    }

    topBarElements.forEach((el) => {
        const toggler = el.querySelector('.js-promotion-top-bar-toggle');

        toggler?.addEventListener('click', (e) => {
            e.preventDefault();

            disactivateTopBar(activeTopBarIndex);
            activeTopBarIndex += 1;
            activateTopBar(activeTopBarIndex);
        });
    });
};
